<form [formGroup]="form" class="flex-col gap-6">
  <div class="flex-row gap-6 lg-flex-col">
    <mat-form-field appearance="outline" class="section-form-field w-100" floatLabel="always">
      <mat-label>{{ 'generic.title' | translate }}</mat-label>
      <input type="text" formControlName="title" matInput>
    </mat-form-field>
    <mat-form-field appearance="outline" class="section-form-field w-100" floatLabel="always">
      <mat-label>{{ 'generic.subtitle' | translate }}</mat-label>
      <input type="text" formControlName="subtitle" matInput>
    </mat-form-field>
  </div>
  <div formArrayName="media">
    @for (media of mediaFormArray?.controls; track media; let index = $index) {
      <div appearance="outline" class="media-item section-form-field w-100" [formGroupName]="index">
        <div class="image-section-container w-100">
          <app-doenkids-image [maxWidth]="200" [maxHeight]="400" [preview]="true" [mediaItem]="media.get('uuid').value" [canReplaceImage]="isAdmin$ | async"></app-doenkids-image>
          @if (!form.disabled) {
            <button type="button" class="close-button" matSuffix mat-icon-button aria-label="Remove" (click)="mediaFormArray.removeAt(index);">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
        <div class="image-input-fields">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'generic.description' | translate }}</mat-label>
            <input type="text" formControlName="description" matInput>
          </mat-form-field>
          @if (media.get('originType')) {
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ 'media.origin_type.label' | translate }}</mat-label>
              <mat-select formControlName="originType">
                <!-- No source and archived sources are no longer offered, only shown on an image that has them (ES-2379). -->
                @if (media.get('originType').value === 'unknown') {
                  <mat-option [value]="'unknown'">{{ 'media.origin_type.unknown' | translate | titlecase }}</mat-option>
                }
                @for (originType of (originTypeOptions$ | async); track originType.id) {
                  @if (!originType.archived || originType.id === media.get('originType').value) {
                    <mat-option [value]="originType.id">
                      {{ originType.name }}
                    </mat-option>
                  }
                }
              </mat-select>
              @if (savingOriginTypes.has(media.get('originType'))) {
                <mat-spinner matSuffix [diameter]="20"></mat-spinner>
              }
            </mat-form-field>
          }
          @if ((isAdmin$ | async) && media) {
            <button mat-button type="button" (click)="replaceImage(media)">
              <mat-icon>sync</mat-icon>&nbsp;
              {{ 'generic.upload_for_replacement' | translate: {purpose: (purpose ? ('select_media.purpose.' + purpose.replace('-', '_')) : '') | translate | lowercase} }}
            </button>
          }
        </div>
      </div>
    }
  </div>
</form>
